<style src="./Textbox.scss" lang="scss" scoped></style>
<template lang="html">
  <label
    class="cp1-textbox"
    :class="{'valid-fail': !isValid}">

    <label class="label">
      <span class="caption">{{ label }}</span>
      <input
        type="text"
        class="cp1-small-textbox textbox"
        v-model="inputValue"
        :placeholder="placeholder"
        @blur="runValidation"
        :autofocus="autofocus"
        v-debounce="debounce"
        :disabled="disabled"
        @debounced="emitDebounce">
    </label>
  </label>
</template>

<script>
import {DebounceDirective} from '../helpers/debounce/Debounce'
import ValidationMixin from '@/components/primitives/validator/validation-mixin/ValidationMixin.js'

export default {
  name: 'Textbox',
  mixins: [
    ValidationMixin
  ],
  directives: {
    debounce: DebounceDirective
  },
  props: {
    label: {
      default: ''
    },
    value: {
      default: ''
    },
    placeholder: {
      default: ''
    },
    autofocus: {
      default: false
    },
    debounce: {
      default: null
    },
    disabled: {
      default: false
    }
  },
  data () {
    return {
      inputValue: ''
    }
  },
  watch: {
    inputValue (pValue, pOldValue) {
      if (pValue !== pOldValue) this.$emit('input', pValue)
    },
    value () {
      this.refreshValues()
    }
  },
  mounted () {
    this.refreshValues()
  },
  methods: {
    blur () {
      this.$emit('blur')
    },
    emitDebounce () {
      this.$emit('debounce', this.inputValue)
    },
    refreshValues () {
      this.inputValue = this.value
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/cp1-textbox/Textbox.vue